/**
 * Determine if objects are shallowly equal.
 */
export function objectsAreShallowEqual(a: object, b: object): boolean {
  const props = {
    a: Object.getOwnPropertyNames(a),
    b: Object.getOwnPropertyNames(b),
  };

  if (props.a.length !== props.b.length) {
    return false;
  }

  return props.a.every((prop) => a[prop] === b[prop]);
}
